import * as React from 'react';
import { IconProps } from '../types';

const IcArrowRight = (props:IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.267 4.454a1.129 1.129 0 0 1 1.591 0l6.75 6.75a1.129 1.129 0 0 1 0 1.592l-6.75 6.75a1.125 1.125 0 0 1-1.591-1.592L18.221 12l-5.954-5.954a1.125 1.125 0 0 1 0-1.592Z"
      fill={props?.fill ?? '#232F3E'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 12c0-.552.506-1 1.13-1h13.74c.624 0 1.13.448 1.13 1s-.506 1-1.13 1H4.63c-.624 0-1.13-.448-1.13-1Z"
      fill={props?.fill ?? '#232F3E'}
    />
  </svg>
);

export default IcArrowRight;